import { ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

/**
 * An extension that allows you to override the rendering of a resource link.
 */
export interface ResourceLinkOptions {
  /** The resource name. */
  name: string;

  /** The text to display for the resource. */
  text: ReactNode;
}

/**
 * An extension that allows you to override the rendering of a resource link.
 */
export interface ResourceLinkExtensionOptions
  extends ItemRenderExtensionOptions<ResourceLinkOptions> {}

export const ResourceLinkExtensions =
  createItemRenderExtensions<ResourceLinkExtensionOptions>({
    id: 'resource-link',
  });

export const createResourceLinkExtension = (
  options: ResourceLinkExtensionOptions,
) => {
  return createItemRenderExtension<ResourceLinkExtensionOptions>(options);
};

export const useResourceLinkExtensions = () => {
  return useItemRenderExtensions<ResourceLinkExtensionOptions>(
    ResourceLinkExtensions,
  );
};
